import useSnackbar from 'hooks/useSnackbar'

import { ConfirmationDialog } from 'components'
import * as service from 'service'
import errorMessage from 'helpers/formatters/errorMessage'

const DialogDelete = ({ open, setOpen, sellerId, refresh }) => {
  const snackbar = useSnackbar()

  const handleDelete = async () => {
    try {
      await service.dponet.sellers.destroy(sellerId)

      refresh()
      snackbar.open({
        message: 'Vendedor/Parceiro excluído com sucesso.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro ao excluir o Vendedor/Parceiro.',
        variant: 'error',
      })
    } finally {
      setOpen(false)
    }
  }

  return (
    <ConfirmationDialog
      open={open}
      message="Tem certeza que deseja excluir este Vendedor/Parceiro?"
      setOpen={setOpen}
      actionAcceptButton={handleDelete}
    />
  )
}

export default DialogDelete
